<template>
  <div data-testid="my-email-opt-outs">
    <!-- FT-188 «Мои письма»: виды необязательных писем компании для своего адреса. Отключения всей компании —
         в настройках компании (блок «Письма компании»); здесь они видны выключенными и неактивными. -->
    <p class="caption grey--text mb-2">{{ $t("email_opt_outs.mine.description") }}</p>
    <p v-if="!notifyEmail" class="caption warning--text mb-2" data-testid="my-email-notify-off">
      {{ $t("email_opt_outs.mine.notify_off_hint") }}
    </p>
    <v-progress-linear v-if="loading" indeterminate height="2" class="mb-2"></v-progress-linear>
    <div v-for="row in kinds" :key="row.kind">
      <v-switch
        :input-value="!row.disabled && !row.company_disabled"
        :label="$t(`email_opt_outs.kinds.${row.kind}`)"
        :disabled="busy || row.company_disabled"
        :data-testid="`my-email-kind-${row.kind}`"
        class="mt-0 mb-1"
        dense
        hide-details
        @change="toggle(row, $event)"
      ></v-switch>
      <p v-if="row.company_disabled" class="caption grey--text ml-12 mb-1">
        {{ $t("email_opt_outs.mine.company_disabled_hint") }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "MyEmailOptOuts",
  data() {
    return {
      kinds: [],
      notifyEmail: true,
      loading: false,
      // Вид, по которому идёт запрос; null — свободно. v-switch переключает себя сам, поэтому на время
      // запроса недоступны все переключатели — проигнорированный клик оставил бы чужое состояние.
      pending: null,
    };
  },
  computed: {
    busy() {
      return this.pending !== null;
    },
    authHeaders() {
      return { headers: { Authorization: this.$store.getters.getAuthToken } };
    },
  },
  created() {
    this.fetch();
  },
  methods: {
    fetch() {
      this.loading = true;
      return this.axios
        .get("/api/v1/email_opt_outs/mine", this.authHeaders)
        .then((response) => {
          this.kinds = response.data.kinds || [];
          this.notifyEmail = response.data.notify_email !== false;
        })
        .catch((error) => this.setError(error, this.$t("email_opt_outs.load_error")))
        .finally(() => (this.loading = false));
    },
    // Переключатель включён = письма приходят на мой адрес. Ошибка — откат к состоянию сервера.
    async toggle(row, enabled) {
      if (this.busy) return;
      const snapshot = { ...row };
      this.pending = row.kind;
      row.disabled = !enabled;
      try {
        if (enabled) {
          await this.axios.delete(`/api/v1/email_opt_outs/mine/${row.kind}`, this.authHeaders);
        } else {
          await this.axios.post("/api/v1/email_opt_outs/mine", { kind: row.kind }, this.authHeaders);
        }
      } catch (error) {
        Object.assign(row, snapshot);
        this.setError(error, this.$t("email_opt_outs.save_error"));
      } finally {
        this.pending = null;
      }
    },
  },
};
</script>
